import DashboardLayout2 from "@/layouts/mandat/DashboardLayout.vue";
import Dashboard2 from "@/layouts/mandat/Dashboard.vue";
import UserProfile from "@/views/shared/UserProfile.vue";
import ConseillerUser from "@/views/shared/ConseillerUser.vue";
import DetailsRecommandations from "@/views/mandat/employe/DetailsRecommandations.vue";
import GestionRecommandations2 from "@/views/mandat/employe/GestionRecommandations.vue";
import AllRecommandations2 from "@/views/mandat/admin/AllRecommandations.vue";
import ActionsRecommandations from "@/views/mandat/client/ActionsRecommandations.vue";
import StatisTiques from "@/layouts/mandat/StatisTiques.vue";
import SuiviRecommandations from "@/layouts/mandat/SuiviRecommandations.vue";
import GesUserPage from "@/views/shared/admin/GesUserPage.vue";

import { ROLES, STAFF_ROLES, redirectActionsMandatRoot } from "./constants";
import { PERMISSIONS } from "@/utils/permissions";

export const module2Routes = [
  {
    path: "/actions-mandat",
    component: DashboardLayout2,
    redirect: redirectActionsMandatRoot,
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboards",
        name: "Tableau de bord des actions mandat",
        component: Dashboard2,
        meta: { requiresRole: STAFF_ROLES },
      },
      { path: "profil", name: "Mon Profil", component: UserProfile },
      {
        path: "actions-statistiques",
        name: "Statistiques des actions mandat",
        component: StatisTiques,
        meta: { requiresRole: STAFF_ROLES },
      },
      { path: "contact", name: "Contacter un conseiller", component: ConseillerUser },
      {
        path: "suivi-recommandations",
        name: "Suivi des recommandations",
        component: SuiviRecommandations,
        meta: { requiresRole: STAFF_ROLES },
      },
      {
        path: "mes-recommandations",
        name: "Mes recommandations - mandat",
        component: ActionsRecommandations,
        meta: { requiresRole: [ROLES.USER, "client"] },
      },
      {
        path: "gestion-utilisateur",
        name: "Gestion des utilisateurs des actions mandat",
        component: GesUserPage,
        props: { variant: "extended" },
        meta: {
          requiresAnyPermission: [PERMISSIONS.GESTION_UTILISATEURS],
          requiresRole: STAFF_ROLES,
        },
      },
      {
        path: "all-recommandations",
        name: "Toutes les recommandations des clients",
        component: AllRecommandations2,
        meta: { requiresRole: ROLES.ADMIN },
      },
      {
        path: "client-recommandations",
        name: "Recommandations des clients",
        component: GestionRecommandations2,
        meta: { requiresRole: [ROLES.EMPLOYE, "saisie", "validation"] },
      },
      {
        path: "nouvelle-action-recommandation",
        name: "Nouvelle action recommandation",
        component: DetailsRecommandations,
        meta: { requiresRole: [ROLES.EMPLOYE, "saisie", "validation"] },
      },
      {
        path: "actions-recommandations/:id",
        name: "Voir action recommandation",
        component: DetailsRecommandations,
        meta: { requiresRole: [ROLES.EMPLOYE, "saisie", "validation"] },
      },
      {
        path: "actions-recommandations/:id/modifier",
        name: "Modifier action recommandation",
        component: DetailsRecommandations,
        meta: { requiresRole: [ROLES.EMPLOYE, "saisie", "validation"] },
      },
    ],
  },
];
